import { render, staticRenderFns } from "./BSearch.vue?vue&type=template&id=224904d6&scoped=true"
import script from "./BSearch.vue?vue&type=script&lang=js"
export * from "./BSearch.vue?vue&type=script&lang=js"
import style0 from "./BSearch.vue?vue&type=style&index=0&id=224904d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224904d6",
  null
  
)

export default component.exports